import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { lazyUpdateUserConfigurationService } from 'owa-session-store';
import { getParseFolderViewStateWithSortConversionToString } from '../actions/folderViewStatesActions';
import getDefaultSearchScopeForFolderView from '../selectors/getDefaultSearchScopeForFolderView';
import { MailSortHelper } from 'owa-mail-list-store';
import { DEFAULT_LIST_VIEW_WIDTH } from 'owa-mail-layout/lib/mailLayoutConstants';
import getDefaultFolderView from '../selectors/getDefaultFolderView';
import { getFolderTable } from 'owa-folders';
import debounce from 'lodash-es/debounce';
import { logUsage } from 'owa-analytics';

const updateUserConfigurationDebounced = debounce(
    serializedFolderViewState => {
        logUsage('UpdateFolderViewState', {}, { isCore: true });
        lazyUpdateUserConfigurationService.importAndExecute(
            [
                {
                    key: 'FolderViewState',
                    valuetype: 'StringArray',
                    value: serializedFolderViewState,
                },
            ],
            'OWA.ViewStateConfiguration'
        );
    },
    30000,
    { leading: false, trailing: true }
);

/**
 * Delay update the folder view state service
 */
export default function updateFolderViewStateService() {
    const folderViewState = getUserConfiguration().ViewStateConfiguration?.FolderViewState;

    if (folderViewState) {
        const serializedFolderViewState: string[] = [];
        const defaultSortBy = MailSortHelper.getDefaultSortBy();

        for (let i = 0; i < folderViewState.length; i++) {
            // It is not necessary to store default view state on server, we are filtering folders with
            // default view state before updating server.
            const parsedFolderViewState = getParseFolderViewStateWithSortConversionToString(
                folderViewState[i]
            );

            const mailFolder = getFolderTable().get(parsedFolderViewState.FolderId.Id);

            // Only consider IsExpanded for mail folder that has children. If the mail folder cannot be found
            // for any reason, we do not skip its state.
            const ignoreIsExpandedFromFolderViewState =
                !!!mailFolder || mailFolder.hasChildren ? !parsedFolderViewState.IsExpanded : true;

            if (
                ignoreIsExpandedFromFolderViewState &&
                parsedFolderViewState.SearchScope ===
                    getDefaultSearchScopeForFolderView(parsedFolderViewState.FolderId.Id) &&
                parsedFolderViewState.SortColumn === defaultSortBy.sortColumn &&
                parsedFolderViewState.SortOrder === defaultSortBy.sortDirection &&
                parsedFolderViewState.Width === DEFAULT_LIST_VIEW_WIDTH &&
                parsedFolderViewState.ReadingPanePosition ===
                    getUserConfiguration().UserOptions?.GlobalReadingPanePositionReact &&
                parsedFolderViewState.View ===
                    getDefaultFolderView(parsedFolderViewState.FolderId.Id)
            ) {
                continue;
            }

            serializedFolderViewState.push(folderViewState[i]);
        }

        updateUserConfigurationDebounced(serializedFolderViewState);
    }
}
